export const LOCAL_STORAGE_USER_TOKEN_KEY = 'userToken'
export const LOCAL_STORAGE_MODULES = 'MODULES'
export const LOCAL_STORAGE_EMT_DOCUMENT_GLOBAL_ATTRIBUTE_FILTER = 'EMT_Document_Global_Attribute_Filter'
